"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireWildcard(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Popup = _interopRequireDefault(require("./Popup"));

var _calculateTop = _interopRequireDefault(require("./calculateTop"));

var _calculateLeft = _interopRequireDefault(require("./calculateLeft"));

var _calculateArrowPlacement = _interopRequireDefault(require("./calculateArrowPlacement"));

var _calculateArrowCoords = _interopRequireDefault(require("./calculateArrowCoords"));

var s = _interopRequireWildcard(require("./TooltipPopup.style"));

var _class, _temp;

function unmount(node) {
  _reactDom.default.unmountComponentAtNode(node);

  node && node.parentNode.removeChild(node);
}

var TooltipPopup = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TooltipPopup, _React$Component);

  function TooltipPopup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TooltipPopup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TooltipPopup).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setToolTipCoords", function () {
      var _this$props = _this.props,
          placement = _this$props.placement,
          hideArrow = _this$props.hideArrow,
          arrowPointAtCenter = _this$props.arrowPointAtCenter,
          popupContainer = _this$props.popupContainer,
          topOffset = _this$props.topOffset,
          leftOffset = _this$props.leftOffset;
      var top = (0, _calculateTop.default)(_this.tooltipElem.current, _this.popup.current, placement, popupContainer);
      var left = (0, _calculateLeft.default)(_this.tooltipElem.current, _this.popup.current, placement, popupContainer);
      var arrowPlacement;
      var arrowCoords;

      if (!hideArrow) {
        arrowPlacement = (0, _calculateArrowPlacement.default)(_this.tooltipElem.current, _this.popup.current, placement);
        arrowCoords = (0, _calculateArrowCoords.default)(_this.tooltipElem.current, _this.popup.current, placement, arrowPointAtCenter, popupContainer);
      }

      _this.setState({
        top: top + topOffset,
        left: left + leftOffset,
        arrowPlacement: arrowPlacement,
        arrowCoords: arrowCoords
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "showTooltip", function () {
      var _this$props2 = _this.props,
          mouseEnterDelay = _this$props2.mouseEnterDelay,
          onVisibleChange = _this$props2.onVisibleChange;
      setTimeout(function () {
        _this.setState({
          show: true,
          animate: true
        }, function () {
          _this.setToolTipCoords();

          onVisibleChange({
            visible: true
          });
        });
      }, mouseEnterDelay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "hideToolTip", function () {
      var _this$props3 = _this.props,
          mouseLeaveDelay = _this$props3.mouseLeaveDelay,
          onVisibleChange = _this$props3.onVisibleChange;
      setTimeout(function () {
        _this.setState({
          show: false,
          animate: false
        }, function () {
          onVisibleChange({
            visible: false
          });
        });
      }, mouseLeaveDelay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseOver", function (e) {
      var trigger = _this.props.trigger;
      trigger === 'hover' && _this.showTooltip(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onFocus", function (e) {
      var trigger = _this.props.trigger;
      trigger === 'focus' && _this.showTooltip(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function (e) {
      var trigger = _this.props.trigger;
      trigger === 'click' && _this.showTooltip(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseOut", function (e) {
      var _this$props4 = _this.props,
          trigger = _this$props4.trigger,
          visible = _this$props4.visible;
      trigger === 'hover' && !visible && !_this.props.visible && _this.hideToolTip(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBlur", function (e) {
      var _this$props5 = _this.props,
          trigger = _this$props5.trigger,
          visible = _this$props5.visible;
      trigger === 'hover' && !visible && _this.hideToolTip(e);
    });
    var isVisible = !!props.visible || !!props.defaultVisible;
    _this.state = {
      show: isVisible,
      animate: isVisible,
      top: null,
      left: null,
      arrowPlacement: null,
      arrowCoords: {}
    };
    _this.container = document.createElement('div');
    _this.tooltipElem = _react.default.createRef();
    _this.popup = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(TooltipPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.popupContainer) {
        this.props.popupContainer.appendChild(this.container);

        if (this.state.show) {
          this.setToolTipCoords();
        }
      }

      if (this.props.autoAdjustOverflow) {
        window.addEventListener('scroll', this.setToolTipCoords);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.title !== prevProps.title) {
        this.setToolTipCoords();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoAdjustOverflow) {
        window.removeEventListener('scroll', this.setToolTipCoords);
      }

      unmount(this.container);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        role: "button",
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onClick: this.onClick,
        tabIndex: "0",
        ref: this.tooltipElem,
        className: s.rootContainer
      }, this.props.children, (0, _reactDom.createPortal)(_react.default.createElement(_Popup.default, (0, _extends2.default)({}, this.props, this.state, {
        popupref: this.popup,
        hideToolTip: this.hideToolTip
      })), this.container));
    }
  }]);
  return TooltipPopup;
}(_react.default.Component), _temp)) || _class;

TooltipPopup.defaultProps = {
  arrowPointAtCenter: false,
  autoAdjustOverflow: false,
  defaultVisible: false,
  popupContainer: document.body,
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0,
  overlayClassName: '',
  className: '',
  placement: 'default',
  trigger: 'hover',
  visible: false,
  onVisibleChange: function onVisibleChange() {},
  showCross: false,
  hideArrow: false,
  topOffset: 0,
  leftOffset: 0
};
TooltipPopup.prototypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.func]).isRequired,
  arrowPointAtCenter: _propTypes.default.bool,
  autoAdjustOverflow: _propTypes.default.bool,
  // Will work only if placement is default
  defaultVisible: _propTypes.default.bool,
  popupContainer: _propTypes.default.node,
  // Where to append the popup
  mouseEnterDelay: _propTypes.default.number,
  mouseLeaveDelay: _propTypes.default.number,
  overlayClassName: _propTypes.default.string,
  className: _propTypes.default.string,
  placement: _propTypes.default.oneOf(['top', 'left', 'right', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom']),
  trigger: _propTypes.default.oneOf(['hover', 'focus', 'click']),
  visible: _propTypes.default.bool,
  onVisibleChange: _propTypes.default.func,
  showCross: _propTypes.default.bool,
  hideArrow: _propTypes.default.bool,
  topOffset: _propTypes.default.number,
  leftOffset: _propTypes.default.number
};
var _default = TooltipPopup;
exports.default = _default;